// purpose of this middleware is to append access token to the request object centrally
import cookie from 'js-cookie';

const tokenMiddleware = (store) => (next) => (action) => {
  const { user, customer } = store.getState();
  let requestHeaders = {
    'X-Access-Token': customer.customerDetails.data ? customer.customerDetails.data.accessToken : '',
    'X-Agent-Api-Key': user.data && user.data.apiKey,
    'x-agent-identifier': user.data && user.data.userId,
    'X-App-Version': '1.0',
    'X-Phone-Platform': 'order-on-call',
    'X-Pincode': customer.selectedPincode || null,
    'X-API-AUTH': process.env.API_AUTH_KEY_DIAGNOSTICS,
    'X-Default-City': (customer.location && customer.location.data) ? customer.location.data.cityId : '1',
    'X-Device-Id': cookie.get('X-Device-Id'),
  };
  if (action.fetchConfig && action.fetchConfig.requestHeaders) {
    requestHeaders = {
      ...requestHeaders,
      ...action.fetchConfig.requestHeaders
    };
  }
  if (requestHeaders && action.fetchConfig) {
    action.fetchConfig.requestHeaders = requestHeaders;
  }
  next(action);
};

export default tokenMiddleware;
